module.exports = __webpack_public_path__ + "img/banner-serve-phone.f792d7af.png";